export const INSURANCE_STATUS_OPTIONS_CONSTANT = {
  HAS_INSURANCE: 'Has Insurance',
  NO_INSURANCE: 'No Insurance',
}

export const VA_BENEFITS_APPLIED_OPTIONS_CONSTANT = {
  YES: 'Yes',
  NO: 'No',
}

export const MEDICAID_STATUS_OPTIONS_CONSTANT = {
  NOT_APPLIED: 'Not Applied',
  DENIED: 'Denied',
  PENDING: 'Pending',
}
